<template>
	<div class="qingwu">
		<div class="admin_main_block">
			<div class="admin_main_block_top">
				<div class="admin_main_block_left">
					<!-- <div><router-link to="/Admin/withdrawal/userlogform"><el-button type="primary" icon="el-icon-plus">添加</el-button></router-link></div> -->
					<div><el-input v-model="phone" placeholder="请输入用户手机号码"></el-input></div>
					<div><el-input v-model="F_VR_NIC" placeholder="请输入用户昵称"></el-input></div>
					<div><el-input v-model="user_id" placeholder="请输入用户ID"></el-input></div>
					<div>
						<el-select v-model="status" placeholder="审核状态">
							<el-option label="审核状态" value="0"></el-option>
							<el-option label="待审核" value="1"></el-option>
							<el-option label="已驳回" value="2"></el-option>
							<el-option label="已通过" value="3"></el-option>
							<el-option label="打款失败" value="4"></el-option>
							<el-option label="打款成功" value="5"></el-option>
						</el-select>
					</div>
					<div><el-date-picker value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" v-model="times" type="datetimerange"
							range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker></div>
					<div><el-button icon="el-icon-search" @click="get_cash_list">条件筛选</el-button></div>
				</div>

				<!-- <div class="admin_main_block_right">
                    <div><el-button type="danger" icon="el-icon-delete" @click="del(select_id)">批量删除</el-button></div>
                </div> -->
			</div>

			<div class="admin_table_main">
				<el-table :data="list" @selection-change="handleSelectionChange" @sort-change="sortChange">
					<el-table-column type="selection"></el-table-column>
					<el-table-column prop="id" label="#" fixed="left" width="70px">
						<template slot-scope="scope">
							<span style="text-decoration: underline;padding: 6ppx;cursor: pointer;" @click="showInvite(scope.row)">{{scope.row.id}}</span>
						</template>
					</el-table-column>
					<el-table-column label="用户信息">
						<template slot-scope="scope">
							<div v-if="scope.row.user">
								<div class="table-row">
									<span>用户头像：</span>
									<el-avatar shape="circle" :size="30" :src="scope.row.user.F_VR_TOUX"></el-avatar>
								</div>
								<div class="table-row">
									<span>用户昵称：</span>
									<span>{{ scope.row.user.F_VR_NIC}}</span>
								</div>
								<div class="table-row">
									<span>用户ID：</span>
									<span>{{ scope.row.user.id}}</span>
								</div>
								<div class="table-row">
									<span>手机号码：</span>
									<span>{{ scope.row.user.phone}}</span>
								</div>
							</div>
							<span v-else>
								账号不存在(删除/注销)
							</span>
						</template>
					</el-table-column>
					<el-table-column sortable="custom" prop="price" label="提现金额"></el-table-column>
					<el-table-column prop="amount" label="金币数量"></el-table-column>
					<el-table-column prop="audit" label="审核类型">
						<template slot-scope="scope">
							<el-tag type="success" v-if="scope.row.audit ==1">自动审核</el-tag>
							<el-tag type="warning" v-if="scope.row.audit ==2">后台审核</el-tag>
						</template>
					</el-table-column>
					<el-table-column prop="status" label="审核状态">
						<template slot-scope="scope">
							<el-tag type="info" v-if="scope.row.status  ==1">申请</el-tag>
							<el-tag type="danger" v-if="scope.row.status  ==2">驳回</el-tag>
							<el-tag type="success" v-if="scope.row.status  ==3">通过</el-tag>
							<el-tag type="warning" v-if="scope.row.status  ==4">自动打款失败</el-tag>
							<el-tag type="success" v-if="scope.row.status  ==5">打款成功</el-tag>
						</template>
					</el-table-column>
					<el-table-column prop="add_time" label="申请时间"></el-table-column>
					<el-table-column prop="audit_time" label="审核时间"></el-table-column>
					<el-table-column label="操作" fixed="right" width="220px">
						<template slot-scope="scope">
							<el-button icon="el-icon-edit" v-if="scope.row.status===1"
								@click="$router.push({name:'store_withdrawal_userlogform',params:scope.row})">审核</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="admin_table_main_pagination">
					<el-pagination @current-change="current_change" background layout="prev, pager, next,jumper,total"
						:total="total_data" :page-size="page_size" :current-page="current_page"></el-pagination>
				</div>
			</div>
		</div>
		<el-dialog :title="cUser.F_VR_NIC+':'+cUser.id+' 的广告记录'" :visible.sync="inviteDialogVisible" width="50%">
			<el-table :data="list2">
				<el-table-column prop="user_id" label="用户ID" fixed="left" width="70px"></el-table-column>
				<el-table-column label="用户信息">
					<template slot-scope="scope">
						<div v-if="scope.row.user">
							<div class="table-row">
								<span>用户头像：</span>
								<el-avatar shape="circle" :size="30" :src="scope.row.user.F_VR_TOUX"></el-avatar>
							</div>
							<div class="table-row">
								<span>用户昵称：</span>
								<span>{{ scope.row.user.F_VR_NIC}}</span>
							</div>
							<div class="table-row">
								<span>用户ID：</span>
								<span>{{ scope.row.user.id}}</span>
							</div>
						</div>
						<span v-else>
							账号不存在(删除/注销)
						</span>
					</template>
				</el-table-column>
				<el-table-column label="设备信息">
					<template slot-scope="scope">
						手机品牌：{{scope.row.brand}}
						<br>
						手机型号：{{scope.row.brand_model}}
						<br>
						设备ID：{{scope.row.device_id}}
					</template>
				</el-table-column>
				<el-table-column prop="Ecpm" label="Ecpm广告价值" width="120px"></el-table-column>
				<el-table-column prop="add_time" label="观看时间"></el-table-column>
			</el-table>
			<div class="admin_table_main_pagination">
				<el-pagination @current-change="current_change2" background layout="prev, pager, next,jumper,total"
					:total="total_data2" :page-size="page_size2" :current-page="current_page2"></el-pagination>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="inviteDialogVisible = false">关 闭</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		components: {},
		props: {},
		data() {
			return {
				cUser:{},
				list2: [],
				total_data2: 0, // 总条数
				page_size2: 20,
				current_page2: 1,
				inviteDialogVisible:false,
				phone: '',
				status: '0',
				list: [],
				total_data: 0, // 总条数
				page_size: 20,
				current_page: 1,
				select_id: '',
				user_id:'',
				F_VR_NIC:'',
				sort:'',
				direction:'',
				times: '',
			};
		},
		watch: {},
		computed: {},
		methods: {
			sortChange(e){
				let order='desc'
				if(e.order=='ascending'){
					order='asc'
				}
				if(e.order=='descending'){
					order='desc'
				}
				this.current_page=1
				this.sort=e.prop
				this.direction=order
				this.get_cash_list()
			},
			// 分页改变
			current_change2: function(e) {
				this.current_page2 = e;
				this.get_store_list2();
			},
			showInvite(e){
				this.cUser=e.user
				this.inviteDialogVisible=true
				this.get_store_list2()
			},
			get_store_list2: function() {
				this.$get(this.$api.ecmpIndex, {
					page: this.current_page2,
					phone: this.cUser.phone
				}).then((res)=> {
					this.page_size2 = res.data.per_page;
					this.total_data2 = res.data.total;
					this.list2 = res.data.data;
					this.current_page2 = res.data.current_page;
				})
			},
			handleSelectionChange: function(e) {
				let ids = [];
				e.forEach(v => {
					ids.push(v.id);
				});
				this.select_id = ids.join(',');
			},
			get_cash_list: function() {
				let _this = this;
				this.$get(this.$api.withdrawalUserLog, {
					page: this.current_page,
					phone: this.phone,
					status: this.status,
					user_id: this.user_id,
					F_VR_NIC: this.F_VR_NIC,
					sort:this.sort,
					direction:this.direction,
					add_time:JSON.stringify(this.times)
				}).then(function(res) {
					_this.page_size = res.data.per_page;
					_this.total_data = res.data.total;
					_this.current_page = res.data.current_page;
					_this.list = res.data.data;
				})

			},
			// 分页改变
			current_change: function(e) {
				this.current_page = e;
				this.get_cash_list();
			},
			// 删除处理
			// del:function(id){
			//     let _this = this;
			//     if(this.$isEmpty(id)){
			//         return this.$message.error('请先选择删除的对象');
			//     }
			//     this.$post(this.$api.withdrawalDel,{id:id}).then(function(res){
			//         if(res.code == 200){
			//             _this.get_cash_list();
			//             return _this.$message.success("删除成功");
			//         }else{
			//             return _this.$message.error("删除失败");
			//         }
			//     });
			// },
		},
		created() {
			this.get_cash_list();
		},
		mounted() {}
	};
</script>
<style lang="scss" scoped>
.table-row{
	display: flex;
	flex-direction: row;
	align-items: center;
}
</style>